var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import TeamRecommend from "./team-recommend";
import { TeamRankingStatus } from "@/types/teamRanking";
// import { PreInviteParams, QueryPredictCityInfoResponse, RecommendPoiResponse, TeamInfoVO, TeamRankingFreeResponse, TeamRankingStatus } from "@/types/teamRanking";
import ActivityInvalid from "../activity-invalid";
import { useEffect, useState, createElement } from "@max/max";
import { API_PATH, RequestStatus, useRequest } from "@/hooks/useRequest";
import TeamInfo from "./team-info";
import InvitePopup from "../invite-popup";
import { useMonitorEngineContext, useMonitorJumper } from "@nibfe/mcp-monitor-sdk";
import JoinedPopup from "../joined-popup";
import CreatedPopup from "../created-popup";
import RewardRecords from "../reward-records";
import { useRewards } from "@/hooks/useRewards";
import RankingList from "./ranking-list";
import { useRankingList } from "@/hooks/useRankingList";
import PublicityPopup from "../publicity-popup";
import { useLoading } from "@/hooks/useLoading";
import NoticePopup from "../notice-popup";
import TeamStageResult from "./team-stage-result";
import { useOrderPopup } from "@/hooks/useOrderPopup";
import { BID_MAP, POPUP_ORDER } from "@/const";
import { ACTIVITY_BLOKCED_CODE, TEAM_IS_FULL_CODE } from "@/types/shared";
import Sensor from "@max/mbc-sensor";
import TaskPopup from "../task-popup";
import WishSelectionPopup from "../wish-selection-popup";
import { useCallRecords } from "@/hooks/useCallRecords";
import { usePreInvite } from "@/hooks/usePreInvite";
import { getPlatformType, isDianpingAppOrWebview, isMeituanAppOrWebview, isWeixinMiniProgramOrWeixinWebview, PlatformType } from "@nibfe/mkt-env-api";
import { convertLinkToAppMiddleOpenLink, isH5URL } from '@/utils/common';
import { navigateTo } from '@max/meituan-uni-navigate';
import { convertH5ToWebviewPath } from '@nibfe/mkt-navigate-api';
import BountyTask from '@/components/team-ranking/bounty-task';
export default function TeamRanking(props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    const ctx = useMonitorEngineContext();
    const { monitorNavigateToSmart } = useMonitorJumper();
    const [joinedPopupVisible, setJoinedPopupVisible] = useOrderPopup(false, POPUP_ORDER.JOINED_TEAM);
    const [createdPopupVisible, setCreatedPopupVisible] = useOrderPopup(false, POPUP_ORDER.CREATED_TEAM);
    const [publicityPopupVisible, setPublicityPopupVisible] = useOrderPopup(false, POPUP_ORDER.PUBLICITY);
    const { openLoading, closeLoading } = useLoading();
    const { request: operateTeam } = useRequest(API_PATH.JOIN_OR_CREATE_TEAM, {
        method: 'POST',
        showLoading: true,
        raw: true
    });
    const { userId } = ctx._runtimeInfo.commonParams;
    const { inviteType, inviter, rewardId, groupId, teamName } = ((_a = ctx._runtimeInfo) === null || _a === void 0 ? void 0 : _a.queryParams) || {};
    // const { inviteType, inviter, rewardId, groupId, teamName } = {
    //     inviter: 906698074,
    //     inviteType: InviteType.INVITE_CALL,
    //     invite_source: 'share',
    //     groupId: 23283764,
    //     teamName: "包包",
    //   };
    const [rankingVisible, setRankingVisible] = useState(false);
    const { rankingList, status: rankingStatus, hasMore, loadRankingList, loadMore } = useRankingList({
        activityId: props.activityId,
        taskId: props.teamRankingId,
        pageSize: props.rankingListPageSize || 10
    });
    const [rewardRecordsVisible, setRewardRecordsVisible] = useState(false);
    const { rewardsData, requestStatus: rewardsStatus, loadRewardsData } = useRewards({
        activityId: props.activityId
    });
    const { callRecordsData, requestStatus: callRecordsStatus, loadCallRecordsData, loadMoreCallRecords, couponInfos } = useCallRecords({
        activityId: props.activityId,
        pageSize: 10
    });
    const { executePreInvite } = usePreInvite();
    // 心愿选择弹窗状态
    const [wishSelectionVisible, setWishSelectionVisible] = useState(false);
    const [selectedWishId, setSelectedWishId] = useState(undefined);
    const { teamRankingStatus, requestStatus, fetchTeamRankingData, teamRankingData, updateWish, inTeam, teamInfo, done: teamRankingDone, noticePopupVisible, setNoticePopupVisible } = props.teamRankingStates;
    const { invitePopupVisible, setInvitePopupVisible, gotInvitePoints, inviteTeamValue, requestInviteBrowse } = props.invitePopupStates;
    useEffect(() => {
        if (teamRankingStatus === TeamRankingStatus.PUBLICITY) {
            openLoading('请稍候');
            loadRankingList().then(() => {
                setPublicityPopupVisible(true);
            }).catch(() => {
                ctx._uiInteractionAPI.toast.show({
                    content: '获取公示期数据失败'
                });
            }).finally(() => {
                closeLoading();
            });
        }
    }, [teamRankingStatus]);
    if (!teamRankingDone) {
        return null;
    }
    if (requestStatus === RequestStatus.ERROR || !teamRankingData) {
        return <ActivityInvalid type="error" btnProps={{
            text: '重试',
            onPress: () => props === null || props === void 0 ? void 0 : props.initRequest()
        }} text="网络走丢了，请重试" showBtn/>;
    }
    if (teamRankingStatus === TeamRankingStatus.OFFLINE) {
        return <ActivityInvalid type="error" text="活动已结束，请持续关注美团酒店活动～"/>;
    }
    function jumpToOrder() {
        var _a, _b, _c, _d;
        const isInWX = isWeixinMiniProgramOrWeixinWebview();
        if (isInWX) {
            if (!props.gotoOrderUrlInWX)
                return;
            const platform = getPlatformType();
            const webviewUrl = platform === PlatformType.mtMinaWebview ?
                // 对美团小程序有特殊逻辑，使用酒小的WebView打开
                isH5URL(props.gotoOrderUrlInWX) ? `/hotel/pages/h5/index?q=${encodeURIComponent(props.gotoOrderUrlInWX)}` : props.gotoOrderUrlInWX : convertH5ToWebviewPath(props.gotoOrderUrlInWX, platform);
            return navigateTo({
                url: webviewUrl,
                _web: {
                    miniProgramNative: true
                }
            });
        }
        else if (isMeituanAppOrWebview() || isDianpingAppOrWebview()) {
            // app、h5跳转
            if (!props.gotoOrderUrlInMt)
                return;
            navigateTo({
                url: `${props.gotoOrderUrlInMt}${((_a = props.predictCityInfoData) === null || _a === void 0 ? void 0 : _a.predictMtCityId) ? "&city_id=" + ((_b = props.predictCityInfoData) === null || _b === void 0 ? void 0 : _b.predictMtCityId) : ""}`
            });
        }
        else {
            // 兜底
            navigateTo({
                url: convertLinkToAppMiddleOpenLink(`${props.gotoOrderUrlInMt}${((_c = props.predictCityInfoData) === null || _c === void 0 ? void 0 : _c.predictMtCityId) ? "&city_id=" + ((_d = props.predictCityInfoData) === null || _d === void 0 ? void 0 : _d.predictMtCityId) : ""}`)
            });
        }
    }
    function joinTeam(groupId, leaderId) {
        var _a, _b, _c, _d, _e, _f, _g;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (!groupId || !leaderId) {
                    throw new Error('groupId or leaderId is required');
                }
                props.lxReport(BID_MAP.TEAM_JOIN_MC);
                const res = yield operateTeam({
                    groupId,
                    activityId: props.activityId,
                    taskId: props.teamRankingId,
                    operate: 2,
                    teamLeaderId: leaderId
                });
                if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.code) === TEAM_IS_FULL_CODE) {
                    ctx._uiInteractionAPI.toast.show({
                        content: '队伍已满员，换个队伍试试吧～'
                    });
                    return;
                }
                if (((_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.code) === ACTIVITY_BLOKCED_CODE) {
                    ctx._uiInteractionAPI.toast.show({
                        content: '抱歉无法加入，请重试～'
                    });
                    return;
                }
                if (((_c = res === null || res === void 0 ? void 0 : res.data) === null || _c === void 0 ? void 0 : _c.code) !== 0) {
                    throw new Error('加入队伍失败');
                }
                yield fetchTeamRankingData();
                setInvitePopupVisible(false);
                setJoinedPopupVisible(true);
            }
            catch (error) {
                (_e = (_d = ctx._raptorReport).monitorReportBizFailed) === null || _e === void 0 ? void 0 : _e.call(_d, {
                    apiPath: API_PATH.JOIN_OR_CREATE_TEAM
                });
                (_g = (_f = ctx._raptorReport).monitorReportLog) === null || _g === void 0 ? void 0 : _g.call(_f, 'joinTeam', error, {
                    level: 'error',
                    category: 'ajaxError'
                });
                ctx._uiInteractionAPI.toast.show({
                    content: '加入队伍失败'
                });
            }
        });
    }
    function preInvite(params) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield executePreInvite({
                    activityId: props.activityId,
                    groupId: groupId || -1,
                    inviteName: teamName || '',
                    followerId: Number(userId),
                    leaderId: Number(inviter),
                    taskId: params.taskId
                });
            }
            catch (error) {
                console.error('preInvite error:', error);
            }
            finally { }
        });
    }
    function updateUserWish(wishCode) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield updateWish({
                    activityId: props.activityId,
                    groupId: (teamInfo === null || teamInfo === void 0 ? void 0 : teamInfo.groupId) || -1,
                    // taskId: props.teamRankingId,
                    taskId: props.wishTaskId,
                    wishCode: wishCode,
                    operate: 5,
                    teamLeaderId: teamInfo === null || teamInfo === void 0 ? void 0 : teamInfo.teamLeaderId
                });
                // 刷新
                yield fetchTeamRankingData();
            }
            catch (error) {
                console.error('updateUserWish error:', error);
            }
            finally { }
        });
    }
    function inviteBrowse(params, isGoToListPage = false) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                requestInviteBrowse(params.taskId || 0);
            }
            catch (error) {
                console.error('inviteBrowse error:', error);
                // 确保错误被正确处理，避免影响React Native桥接通信
            }
            finally {
                // 跳转去下单列表页
                if (isGoToListPage)
                    jumpToOrder();
                // 跳转推荐酒店详情页
                else
                    (_a = props.browseRecommendedHotelPoi) === null || _a === void 0 ? void 0 : _a.call(props);
            }
        });
    }
    function createTeam(canRec) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                props.lxReport(BID_MAP.TEAM_CREATE_MC);
                const res = yield operateTeam({
                    activityId: props.activityId,
                    taskId: props.teamRankingId,
                    canRec,
                    operate: 1
                });
                if (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.code) === ACTIVITY_BLOKCED_CODE) {
                    ctx._uiInteractionAPI.toast.show({
                        content: '抱歉无法创建，请重试～'
                    });
                    return;
                }
                if (((_b = res === null || res === void 0 ? void 0 : res.data) === null || _b === void 0 ? void 0 : _b.code) !== 0) {
                    throw new Error('创建队伍失败');
                }
                yield fetchTeamRankingData();
            }
            catch (error) {
                ctx._uiInteractionAPI.toast.show({
                    content: '创建队伍失败, 请稍后重试'
                });
            }
        });
    }
    function openRanking() {
        props === null || props === void 0 ? void 0 : props.lxReport(BID_MAP.RANKING_LIST_MC);
        setRankingVisible(true);
        loadRankingList();
    }
    function openRewardRecord() {
        props === null || props === void 0 ? void 0 : props.lxReport(BID_MAP.REWARD_LIST_MC);
        setRewardRecordsVisible(true);
        loadRewardsData();
        loadCallRecordsData();
    }
    function openWishPopup() {
        setWishSelectionVisible(true);
    }
    const onShareRedNote = () => {
        var _a;
        const { wishCode } = teamInfo || {};
        let redNoteImage;
        let redNoteContent;
        if (wishCode) {
            const targetWishConfig = props.wishOptions.find(item => item.id === wishCode);
            if (targetWishConfig) {
                redNoteImage = targetWishConfig.redBookSharePoster;
                redNoteContent = targetWishConfig.redBookShareText;
            }
        }
        props === null || props === void 0 ? void 0 : props.lxReport(BID_MAP.RED_NOTE_SHARE_MC, {
            code: wishCode,
            url: redNoteImage
        });
        console.log('小红书分享点击事件', redNoteImage, redNoteContent);
        (_a = ctx === null || ctx === void 0 ? void 0 : ctx._communication) === null || _a === void 0 ? void 0 : _a.emit("changeRedNotePicTextShareShow", {
            isShow: true,
            imageList: redNoteImage ? [redNoteImage] : [],
            contentList: redNoteContent ? [redNoteContent] : []
        });
    };
    const onRedNoteAudit = () => {
        console.log('小红书发布点击事件');
        const { bountyAuditPageUrl } = props.bountyTaskConfig || {};
        props === null || props === void 0 ? void 0 : props.lxReport(BID_MAP.RED_NOTE_AUDIT_MC);
        bountyAuditPageUrl && monitorNavigateToSmart(bountyAuditPageUrl);
    };
    return <Sensor onLayout={props.onAnchorLayout}>
      <TeamInfo x-if={inTeam && teamRankingStatus === TeamRankingStatus.IN_PROGRESS} teamInfo={(_b = teamRankingData === null || teamRankingData === void 0 ? void 0 : teamRankingData.extra) === null || _b === void 0 ? void 0 : _b.teamInfo} onInviteMember={props.onInviteMember} onInviteCall={props.onInviteCall} onOpenRewardRecord={openRewardRecord} onOpenRanking={openRanking} onOpenWishPopup={openWishPopup} callValueToPointsDesc={props.textConfig.callValueToPointsDesc || '500心愿值=100积分'} targetRankTeamValue={(_c = teamRankingData === null || teamRankingData === void 0 ? void 0 : teamRankingData.extra) === null || _c === void 0 ? void 0 : _c.targetRankTeamValue} inviteCallBadgeText={props.textConfig.inviteCallBadgeText} freeCardMaxAmount={props.textConfig.freeCardMaxAmount || 666} callValueDesc={props.textConfig.callValueDesc}/>

      

      <TeamStageResult x-if={teamRankingStatus === TeamRankingStatus.PUBLICITY || teamRankingStatus === TeamRankingStatus.WON_REWARD || teamRankingStatus === TeamRankingStatus.CALCULATING} teamInfo={(_d = teamRankingData === null || teamRankingData === void 0 ? void 0 : teamRankingData.extra) === null || _d === void 0 ? void 0 : _d.teamInfo} teamRankingStatus={teamRankingStatus} onOpenRewardRecord={openRewardRecord} onOpenRewardRanking={() => {
        setPublicityPopupVisible(true);
    }} onUseFreeCard={openRewardRecord} onOpenRanking={openRanking} noTeamInvalidText={props.textConfig.noTeamInvalidText} rankingListTime={props.rankingListTime} subscribeConfig={props.subscribeConfig} callValueDesc={props.textConfig.callValueDesc}/>

      <TeamRecommend x-if={!inTeam && teamRankingStatus === TeamRankingStatus.IN_PROGRESS} recTeamList={(_e = teamRankingData === null || teamRankingData === void 0 ? void 0 : teamRankingData.extra) === null || _e === void 0 ? void 0 : _e.recTeamList} onCreateTeam={(canRec) => __awaiter(this, void 0, void 0, function* () {
        createTeam(canRec);
    })} onJoinTeam={(groupId, leaderId) => __awaiter(this, void 0, void 0, function* () {
        yield joinTeam(groupId, leaderId);
    })} lxReport={props.lxReport} inviteTeamInfo={(_f = teamRankingData === null || teamRankingData === void 0 ? void 0 : teamRankingData.extra) === null || _f === void 0 ? void 0 : _f.inviteTeamInfo} callValueDesc={props.textConfig.callValueDesc}/>

      <InvitePopup invitePopupVisible={invitePopupVisible} closeInviteCallPopup={() => {
        setInvitePopupVisible(false);
    }} inTeam={inTeam} gotInvitePoints={gotInvitePoints} inviteTeamValue={inviteTeamValue} rewardAmount={props.textConfig.inviteCallPointsAmount || 100} rewardDesc={props.textConfig.inviteCallPointsDesc} noRewardDesc={props.textConfig.inviteCallNoPointsDesc || '加入打call队伍，有机会免费住酒店！'} callValueDesc={props.textConfig.callValueDesc} onClickJoinTeam={() => __awaiter(this, void 0, void 0, function* () {
        var _r, _s, _t, _u;
        yield joinTeam((_s = (_r = teamRankingData === null || teamRankingData === void 0 ? void 0 : teamRankingData.extra) === null || _r === void 0 ? void 0 : _r.inviteTeamInfo) === null || _s === void 0 ? void 0 : _s.groupId, (_u = (_t = teamRankingData === null || teamRankingData === void 0 ? void 0 : teamRankingData.extra) === null || _t === void 0 ? void 0 : _t.inviteTeamInfo) === null || _u === void 0 ? void 0 : _u.teamLeaderId);
        fetchTeamRankingData();
    })} onClickCreateTeam={() => {
        createTeam(true);
    }} onClickInviteCall={props.onInviteCall} inviteCallBadgeText={props.textConfig.inviteCallBadgeText} 
    // 第一个必须配浏览任务，虽然写的很抽象，但是还是得这么写，想不出更好的方法了
    inviteBrowse={() => {
        var _a;
        inviteBrowse({
            taskId: Number((_a = props.tasksConfig) === null || _a === void 0 ? void 0 : _a[0].taskId)
        }, !props.isLaunchPoiDetail);
    }} lxReport={props.lxReport} 
    // callValueDesc={props.textConfig.callValueDesc}
    autoJumpBrowsePageDuration={props.autoJumpBrowsePageDuration || 0}/>

      <JoinedPopup visible={joinedPopupVisible} onClose={() => {
        setJoinedPopupVisible(false);
    }} onInviteCall={props.onInviteCall} inviteCallBadgeText={props.textConfig.inviteCallBadgeText}/>

      <CreatedPopup visible={createdPopupVisible} onClose={() => setCreatedPopupVisible(false)} onInviteCall={props.onInviteCall} inviteCallBadgeText={props.textConfig.inviteCallBadgeText}/>

      <RewardRecords rewardRecordsVisible={rewardRecordsVisible} onClose={() => setRewardRecordsVisible(false)} rewardsData={rewardsData} rewardsStatus={rewardsStatus} callRecordsData={callRecordsData} callRecordsStatus={callRecordsStatus} loadMoreCallRecords={loadMoreCallRecords} 
    // @ts-expect-error
    pointsExchangeable={((_g = teamRankingData === null || teamRankingData === void 0 ? void 0 : teamRankingData.extra) === null || _g === void 0 ? void 0 : _g.canExchangePoint) || false} onFetchRewardsData={loadRewardsData} onExchangePoints={() => {
        fetchTeamRankingData();
        loadRewardsData();
    }} onInviteUnlock={props.onInviteUnlock} groupId={(_j = (_h = teamRankingData === null || teamRankingData === void 0 ? void 0 : teamRankingData.extra) === null || _h === void 0 ? void 0 : _h.teamInfo) === null || _j === void 0 ? void 0 : _j.groupId} activityId={props.activityId} taskId={props.teamRankingId} rewardRecordPointsDesc={props.textConfig.rewardRecordPointsDesc || '酒店积分奖励，积分当钱花'} freeCardDesc={props.textConfig.freeCardDesc || '离店后5个工作日到帐'} onShareFreeCard={props.onShareFreeCard} lxReport={props.lxReport} freeCardMaxAmount={props.textConfig.freeCardMaxAmount || 666} gotoOrderUrlInMt={props.gotoOrderUrlInMt} gotoOrderUrlInWX={props.gotoOrderUrlInWX} callValueDesc={props.textConfig.callValueDesc} couponInfos={couponInfos}/>

      <TaskPopup taskPopupVisible={props.tasksPopupStates.taskPopupVisible} onClose={() => props.tasksPopupStates.setTaskPopupVisible(false)} tasksConfig={props.tasksConfig} tasksData={((_l = (_k = props.tasksPopupStates) === null || _k === void 0 ? void 0 : _k.tasksData) === null || _l === void 0 ? void 0 : _l.tasks) || []} predictCityInfoData={props.predictCityInfoData} tasksStatus={props.tasksPopupStates.tasksStatus} onFetchTasksData={() => {
        var _a, _b;
        (_b = (_a = props.tasksPopupStates).loadTasksData) === null || _b === void 0 ? void 0 : _b.call(_a, {
            leaderId: Number(inviter)
        });
    }} activityId={props.activityId} lxReport={props.lxReport} gotoOrderUrlInMt={props.gotoOrderUrlInMt} gotoOrderUrlInWX={props.gotoOrderUrlInWX} inTeam={inTeam} preInvite={preInvite} inviteBrowse={inviteBrowse} onClickJoinTeam={() => __awaiter(this, void 0, void 0, function* () {
        var _v, _w, _x, _y;
        yield joinTeam((_w = (_v = teamRankingData === null || teamRankingData === void 0 ? void 0 : teamRankingData.extra) === null || _v === void 0 ? void 0 : _v.inviteTeamInfo) === null || _w === void 0 ? void 0 : _w.groupId, (_y = (_x = teamRankingData === null || teamRankingData === void 0 ? void 0 : teamRankingData.extra) === null || _x === void 0 ? void 0 : _x.inviteTeamInfo) === null || _y === void 0 ? void 0 : _y.teamLeaderId);
        fetchTeamRankingData();
    })}/>

      <RankingList rankingVisible={rankingVisible} onClose={() => setRankingVisible(false)} rankingStatus={rankingStatus} rankingList={rankingList} contributionList={(_o = (_m = teamRankingData === null || teamRankingData === void 0 ? void 0 : teamRankingData.extra) === null || _m === void 0 ? void 0 : _m.teamInfo) === null || _o === void 0 ? void 0 : _o.members} hasMore={hasMore} loadMore={loadMore} loadType={props.rankingListLoadType} pokeRemindText={(_p = props === null || props === void 0 ? void 0 : props.textConfig) === null || _p === void 0 ? void 0 : _p.pokeRemindText} callValueDesc={props.textConfig.callValueDesc} onInviteCall={props.onInviteCall} lxReport={props.lxReport} wishOptions={props.wishOptions}/>

      <PublicityPopup visible={publicityPopupVisible} onClose={() => {
        setPublicityPopupVisible(false);
    }} winnerTeams={rankingList} teamInfo={(_q = teamRankingData === null || teamRankingData === void 0 ? void 0 : teamRankingData.extra) === null || _q === void 0 ? void 0 : _q.teamInfo} loadMore={loadMore} callValueDesc={props.textConfig.callValueDesc}/>

      <NoticePopup visible={noticePopupVisible} onClose={() => setNoticePopupVisible(false)} onInviteCall={props.onInviteCall} inviteCallBadgeText={props.textConfig.inviteCallBadgeText}/>

      <WishSelectionPopup visible={wishSelectionVisible} onClose={() => setWishSelectionVisible(false)} onConfirm={(selectedWishId) => __awaiter(this, void 0, void 0, function* () {
        setSelectedWishId(selectedWishId);
        setWishSelectionVisible(false);
        yield updateUserWish(selectedWishId);
        ctx._uiInteractionAPI.toast.show({
            content: '心愿设置成功'
        });
    })} wishOptions={props.wishOptions} selectedWishId={selectedWishId}/>
      <BountyTask x-if={props.isBountyTaskValid} bountyTaskConfig={props.bountyTaskConfig} onShareRedNote={onShareRedNote} onRedNoteAudit={onRedNoteAudit} lxReport={props.lxReport}/>
    </Sensor>;
}
